import * as THREE from 'three'
import GUI from 'lil-gui'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import gsap from 'gsap'

/**
 * Loaders
 */
const loadingManager = new THREE.LoadingManager(
    () => {
        gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0 })
    },
    () => {
        console.log('Loading progress...');
    }
)

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Overlay
 */
const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1)
const overlayMaterial = new THREE.ShaderMaterial({
    transparent: true,
    uniforms: {
        uAlpha: { value: 1 }
    },
    vertexShader: `
        void main() {
            gl_Position = vec4(position, 1.0);
        }
    `,
    fragmentShader: `
        uniform float uAlpha;
        void main() {
            gl_FragColor = vec4(1.0, 1.0, 1.0, uAlpha); 
        }
    `
})
const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
scene.add(overlay)

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader(loadingManager)
const matcapTexture = textureLoader.load('/matcaps/10.png')
matcapTexture.colorSpace = THREE.SRGBColorSpace

/**
 * Material
 */
// const material = new THREE.MeshToonMaterial({
//     color: parameters.materialColor,
//     gradientMap: textureLoader.load('/gradients/3.jpg')
//})

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
window.addEventListener('resize', () => {
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 6
scene.add(camera)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()
const tick = () => {
    const elapsedTime = clock.getElapsedTime()
    renderer.render(scene, camera)
    window.requestAnimationFrame(tick)
}
tick()

// Event listeners to header links
const headerLinks = document.querySelectorAll('header nav a');
headerLinks.forEach(link => {
    link.addEventListener('click', (event) => {
        event.preventDefault();
        const targetUrl = event.target.href;

        // Start the overlay animation
        gsap.to('#white-overlay', {
            duration: 1,
            opacity: 1,
            onComplete: () => {
                window.location.href = targetUrl;
            }
        });
    });
});

// Fade-in effect on page load
window.addEventListener('load', () => {
    document.body.classList.add('loaded');
});